import { AirportMapPinType, getAirportMapPin } from "./pins/AirportPin";
import { getGroundTransportMapPin, GroundTransportMapPinType } from "./pins/GroundTransportPin";
import { getMultipleMapPin, MultipleMapPinType } from "./pins/MultiPin";
import { getShowMapPin, ShowMapPinType } from "./pins/ShowPin";
import { getVenueMapPin, VenueMapPinType } from "./pins/VenuePin";

type DefaultMapPinType = {
  type: "default";
}

export type MapPinType =
  DefaultMapPinType |
  ShowMapPinType |
  GroundTransportMapPinType |
  VenueMapPinType |
  AirportMapPinType |
  MultipleMapPinType;

export const getMapPin = (pin: MapPinType) => {
  switch (pin.type) {
    case "show":
      return getShowMapPin(pin);
    case "venue":
      return getVenueMapPin();
    case "groundTransport":
      return getGroundTransportMapPin(pin);
    case "airport": 
      return getAirportMapPin();
    case "multiple":
      return getMultipleMapPin(pin);
    default:
      return getDefaultMapPin();
  }
};

const getDefaultMapPin = () => {
  return new google.maps.marker.PinElement({}).element;
};